import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";
import { TextField, SelectField } from "@syos-music/form";

import { Button, Grid, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import IntlTextField from "components/form/IntlTextField";

const MUTATION = gql`
  mutation (
    $name: String!
    $label: String!
    $clientLabel: IntlStringInput!
    $clientState: OrderClientState!
  ) {
    CreateOrderState(
      name: $name
      label: $label
      clientLabel: $clientLabel
      clientState: $clientState
    ) {
      orderState {
        id
        deleted
        locked
        name
        label
        clientState
      }
    }
  }
`;

export default function CreateOrderState({ onCreate, children }) {
  const [createOrderState] = useMutation(MUTATION);

  const [isOpen, setIsOpen] = React.useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      {children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={(values) =>
            createOrderState({ variables: values })
              .then(({ data }) => {
                close();
                return onCreate?.(data.CreateOrderState.orderState);
              })
              .catch(() => true)
          }
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">
                Créer un êtat de commande
              </Dialog.Title>

              <Dialog.Content>
                <Grid container>
                  <Grid item xs={12}>
                    <TextField name="name" required label="Nom machine" />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="label"
                      required
                      label="Libellé"
                      helperText="Visible dans Lapidou"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <SelectField
                      name="clientState"
                      label="Êtat client"
                      required
                    >
                      <MenuItem value="NEW">new</MenuItem>
                      <MenuItem value="CONFIRMED">confirmed</MenuItem>
                      <MenuItem value="PRODUCTION">production</MenuItem>
                      <MenuItem value="PACKAGING">packaging</MenuItem>
                      <MenuItem value="SHIPPED">shipped</MenuItem>
                      <MenuItem value="FINISHED">finished</MenuItem>
                    </SelectField>
                  </Grid>

                  <Grid item xs={12}>
                    <IntlTextField
                      name="clientLabel"
                      required
                      label="Libellé"
                      helperText="Visible par les clients sur le site"
                    />
                  </Grid>
                </Grid>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton type="submit" loading={submitting}>
                  Créer
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}
